import { useState } from 'react';
import { Link } from 'react-router-dom';
import { apiJson } from '../api/client.js';
import { FieldErrors } from '../components/FieldErrors.jsx';

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');
  const [fieldErrors, setFieldErrors] = useState(/** @type {Record<string, string[]> | undefined} */ (undefined));
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setFieldErrors(undefined);
    setSubmitting(true);
    try {
      await apiJson('/api/forgot-password', {
        method: 'POST',
        body: { email },
        skipAuth: true,
      });
      setDone(true);
    } catch (err) {
      setError(err.message);
      setFieldErrors(err.body?.errors);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth-shell">
      <div className="auth-card">
        <h1>Reset password</h1>
        <p className="muted">We will email you a reset link if the account exists.</p>
        {done ? (
          <p className="success">
            If an account exists for that email, password reset instructions have been sent. Check your inbox.
          </p>
        ) : (
          <form onSubmit={onSubmit} className="stack">
            <label className="field">
              <span>Email</span>
              <input
                type="email"
                autoComplete="email"
                value={email}
                onChange={(ev) => setEmail(ev.target.value)}
                required
              />
            </label>
            {error ? <p className="err">{error}</p> : null}
            <FieldErrors errors={fieldErrors} />
            <button type="submit" className="btn-primary" disabled={submitting}>
              {submitting ? 'Sending…' : 'Send reset link'}
            </button>
          </form>
        )}
        <div className="auth-links">
          <Link to="/">Back to sign in</Link>
        </div>
      </div>
    </div>
  );
}
